import React from 'react';
// import FullCalendar from '@fullcalendar/react'; // must go before plugins
// import dayGridPlugin from '@fullcalendar/daygrid'; // a plugin!
// import interactionPlugin from '@fullcalendar/interaction'; // needed for dayClick

function EventCalendar(props) {
  // const { calendarData, initialDate } = props;

  return (
    <iframe
        src="https://codesandbox.io/embed/nice-water-1v4hzb?fontsize=14&hidenavigation=1&initialpath=%2Fcalendar-tailwind&module=%2Fsrc%2FApp.js&theme=dark&view=preview"
        width="100%"
        height="600px"
        ms="-15px"
        overflow="hidden"
      ></iframe>
    // <FullCalendar
    //   plugins={[dayGridPlugin, interactionPlugin]}
    //   headerToolbar={false}
    //   initialView="dayGridMonth"
    //   contentHeight="600px"
    //   events={calendarData}
    //   initialDate={initialDate}
    //   editable={true}
    //   minHeight="400px"
    //   height="100%"
    //   slotWidth={10}
    //   customIcons={false}
    // />
  );
}

export default EventCalendar;
